module.exports = __webpack_public_path__ + "static/img/course_img2.261359e6.jpg";